import React from 'react'
import { Inscription } from '@/utils/types/inscription'
import Wallet from '@/utils/wallet'
import event from '@/utils/event'
import { useRouter } from 'next/navigation'
import isRune from '@/utils/is-rune'

export default function usePurchaseModal(
	inscription: Inscription,
	{ autoSign = false }: { autoSign?: boolean } = {}
): [loading: boolean, openModal: (evt?: any, isBRC20?: boolean) => Promise<void>] {
	const [loading, _setLoading] = React.useState(false)
	const router = useRouter()

	const openModal = React.useCallback(
		async (evt?: any, isBRC20?: boolean) => {
			evt?.preventDefault()
			evt?.stopPropagation()

			if (loading) {
				return
			}

			if (!Wallet.isSet()) {
				event.emit('snackbar', { title: 'Please create a wallet', variant: 'success' })
				router.push('/create-wallet')
				return
			}

			const inscription_price = inscription.escrow?.satoshi_price
			const market_fee = ((inscription_price as any) * 2.7) / 100
			const brc20 = isBRC20 || !!inscription?.brc20?.ticker

			event.emit('open-purchase-modal', {
				inscription,
				isBRC20: brc20,
				purchaseData: {
					autoSign,
					marketFee: market_fee,
					subtotalPrice: inscription_price,
					rune: isRune(inscription?.collection?.slug as any),
					slug: inscription?.collection?.slug
				}
			})
		},
		[inscription, loading, router, autoSign]
	)

	return [loading, openModal]
}
